import { WidgetType } from "@codemirror/view";

export class TableRenderingErrorWidget extends WidgetType {
    constructor(tableNode) {
        super();
        this.hasTableNode = Boolean(tableNode);
    }

    toDOM() {
        const warning = document.createElement("div");
        warning.classList.add("notification", "notification-type-info");
        warning.role = "alert";

        const icon = document.createElement("div");
        icon.classList.add("notification-icon");
        icon.textContent = "i";
        warning.appendChild(icon);

        const messageWrapper = document.createElement("div");
        messageWrapper.classList.add("notification-content-and-cta");

        const message = document.createElement("div");
        message.classList.add("notification-content");

        const messageHeader = document.createElement("p");
        const strong = document.createElement("strong");
        strong.textContent = "이 표는 현재 visual 모드에서 표시할 수 없습니다.";
        messageHeader.appendChild(strong);

        const messageBody = document.createElement("p");
        messageBody.textContent = "일부 표 요소는 아직 visual 렌더러에서 지원되지 않습니다.";

        message.appendChild(messageHeader);
        message.appendChild(messageBody);
        messageWrapper.appendChild(message);
        warning.appendChild(messageWrapper);

        const element = document.createElement("div");
        element.classList.add("table-generator", "table-generator-error-container");
        element.appendChild(warning);
        if (this.hasTableNode) {
            element.classList.add("ol-cm-environment-table");
        }
        return element;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
